import type { ReactNode } from "react";

type ModalContentProps = {
  children?: ReactNode;
};

export const ModalContent = ({ children }: ModalContentProps) => (
  <>{children}</>
);
